import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  private route = inject(ActivatedRoute);

  showFooter = false;

  constructor() {
    this.route.queryParams.subscribe(params => {
      this.showFooter = params['footer'] === 'true' || false;
    });

    }
}
